export default "__VITE_ASSET__Be5O3AL2__"